/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { Linkable } from '@/components/blocks/Linkable';
import { tileDescriptionSX, linkTitleSX } from '@/components/blocks/ProductDetails/styles/aplazo';
import { Stack, Typography, styled } from '@mui/material';
import { FC, useState } from 'react';
import { AplazoDrawerList } from '@/components/blocks/ProductDetails/AplazoDrawerList';
import { DpDrawer } from '@/components/blocks/DpDrawer';

const Img = styled('img')({
	height: '18px',
	marginLeft: '7px',
	maxWidth: '65.45px',
});

export const ProductDetailsAplazoDisplay: FC = () => {
	const titleAplazo = 'Compra ahora y paga en 5 plazos con';
	const linkAplazoMoreInfo = 'Más info';

	const [open, setOpen] = useState(false);

	const toggleDrawer = (newOpen: boolean) => () => {
		setOpen(newOpen);
	};

	return (
		<Stack
			sx={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				marginTop: '7px !important',
			}}
		>
			<Stack display={'flex'} direction={'row'} flexWrap={'wrap'}>
				<Stack direction={'row'} justifyContent={'center'} alignItems={'center'} pb={'1px'}>
					<Typography sx={tileDescriptionSX}>{titleAplazo}</Typography>
				</Stack>
				<Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={'5px'}>
					<Img src="images/aplazo/aplazo@2x.png" alt="Aplazo" />
				</Stack>
				<Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
					<Linkable href="" type="inline" sx={linkTitleSX} onClick={toggleDrawer(true)}>
						{linkAplazoMoreInfo}
					</Linkable>
				</Stack>
			</Stack>
			<DpDrawer title="Aplazo" open={open} onClose={toggleDrawer(false)}>
				<AplazoDrawerList />
			</DpDrawer>
			{/* <Stack>
				<Img src="images/aplazo/aplazo@2x.png" alt="Aplazo" />
			</Stack> */}
			{/* <Stack sx={{ marginLeft: '7px' }}>
				<Linkable href="" type="inline" sx={linkTitleSX} onClick={toggleDrawer(true)}>
					{linkAplazoMoreInfo}
				</Linkable>
				<DpDrawer title="Aplazo" open={open} onClose={toggleDrawer(false)}>
					<AplazoDrawerList />
				</DpDrawer>
			</Stack> */}
		</Stack>
	);
};
